import React, { Component } from "react";
import Controls from "./Controls";
import Pads from "./Pads";
import Pad from "./Pad";
import Display from "./Display";
import { Player, instruments } from "./sound";

export default class ControlsView extends Component {
  state = {
    selectedInstrument: 0
  };

  selectInstrument = index => {
    this.setState({ selectedInstrument: index });
    Player.selectInstrument(index);
  };

  handleKeyPress = evt => {
    if (evt.key >= "1" && evt.key <= "8") {
      const index = parseInt(evt.key, 10) - 1;
      this.setState({ selectedInstrument: index });
      Player.selectInstrument(index);
    }
  };

  componentDidMount() {
    this.keyPressHandler = document.addEventListener(
      "keydown",
      this.handleKeyPress
    );
  }

  componentWillMount() {
    document.removeEventListener("keydown", this.keyPressHandler);
  }

  render() {
    const { selectedInstrument } = this.state;
    return (
      <Controls>
        <Pads>
          {Array.from(Array(8)).map((value, index) => (
            <Pad
              key={index}
              active={selectedInstrument === index}
              onClick={() => this.selectInstrument(index)}
            />
          ))}
        </Pads>
        <Display>{instruments[selectedInstrument].name}</Display>
      </Controls>
    );
  }
}
